const staging = window.location.href.includes('portal.llt.kairoxlab.xyz');
const prod = window.location.href.includes('portal.lltraslados.com.ar');

const env = {
  backEnd: prod
    ? 'https://back.lltraslados.com.ar/api/'
    :'https://api.llt.kairoxlab.xyz/api/',
  tracker_url: prod
    ? 'https://tracking.lltraslados.com.ar'
    : 'https://qa-llt-travel-tracker.netlify.app',
};
export default env;